export default __webpack_public_path__ + "locales/sk/PrivacyPage.json?hash=80df91938b33e836dba34ecd6e076161";